<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Haberler"
    }
</script>

<style scoped>

</style>